import { Component, Input, OnInit, ViewEncapsulation, } from '@angular/core';
import { Faq } from '@shared/models';
import { FaqService } from '@core/api/faq.service';

@Component({
  selector: 'fc-submission-step-faq',
  templateUrl: './submission-step-faq.component.html',
  styleUrls: ['./submission-step-faq.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class SubmissionStepFaqComponent implements OnInit {
  @Input() pageName: string = null;
  @Input() staticFaqs: any = null;
  @Input() pageHeader: string = 'Common Questions'
  faqs: Faq[] = [];


  constructor(public faqService: FaqService) { }

  ngOnInit(): void {
    if (this.pageName != null) {
      this.faqService.getFaqsByPage(this.pageName).subscribe((faqs: Faq[]) => {
        this.faqs = faqs;
      });
    } else if (this.staticFaqs != null) {
      this.faqs = this.staticFaqs;
    }
  }
}
